/* bubl-parallax.js — GSAP + ScrollTrigger parallax */
(() => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced || !window.gsap || !window.ScrollTrigger) return;

  const { gsap, ScrollTrigger } = window;
  gsap.registerPlugin(ScrollTrigger);

  const sectionSelector = '[id^="bubl-parallax-hero-"]';
  const sections = document.querySelectorAll(sectionSelector);
  if (!sections.length) return;

  sections.forEach((section) => {
    ScrollTrigger.getAll().forEach((trigger) => {
      const trg = trigger.vars && trigger.vars.trigger;
      if (trg && (trg === section || section.contains(trg))) trigger.kill();
    });

    const stages = section.querySelectorAll('.bubl-parallax-hero__stage');
    if (!stages.length) return;

    const applyTransform = (el, depth, rotate, flipY) => {
      const flip = flipY ? ' scaleY(-1)' : '';
      el.style.transform = `translate3d(0,0,${(-300 * depth).toFixed(1)}px) rotate(${rotate}deg)${flip}`;
      el.style.transformStyle = 'preserve-3d';
      el.style.transformOrigin = 'center';
    };

    const items = Array.from(section.querySelectorAll('.bubl')).map((el) => {
      const speed = parseFloat(el.dataset.speed) || 0.5;
      const depth = parseFloat(el.dataset.depth) || 0.5;
      const rotate = parseFloat(el.dataset.rotate) || 0;
      const flipY = String(el.dataset.flipY) === 'true';

      el.style.filter = 'none';
      applyTransform(el, depth, rotate, flipY);

      return { el, speed, depth, rotate, flipY };
    });

    const viewportHeight = () => Math.max(window.innerHeight, 1);
    const sectionHeight = () => Math.max(section.offsetHeight, viewportHeight());
    const sectionTop = () => section.offsetTop;
    const computeStart = () => Math.max(sectionTop() - viewportHeight(), 0);
    const computeEnd = () => sectionTop() + section.offsetHeight;

    items.forEach(({ el, speed }) => {
      const distance = () => sectionHeight() * speed * 0.4;

      gsap.fromTo(
        el,
        { y: 0 },
        {
          y: () => distance(),
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: computeStart,
            end: computeEnd,
            scrub: true,
            fastScrollEnd: true,
            invalidateOnRefresh: true,
          },
        },
      );
    });

    stages.forEach((stageEl) => {
      gsap.fromTo(
        stageEl,
        { rotationX: 0 },
        {
          rotationX: -4,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: computeStart,
            end: computeEnd,
            scrub: true,
            invalidateOnRefresh: true,
          },
        },
      );
    });
  });
})();
